import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { window } from '@wix/native-pro-gallery-utils';
import { useState, useEffect, useMemo } from 'react';
export const useAccessibility = isAccessibilityEnabled => {
  const [isAccessible, setAccessibilityState] = useState(false);
  const accessibilityHelper = useMemo(() => new AccessibilityHelper(setAccessibilityState), []);
  useEffect(() => {
    accessibilityHelper.initAccessibility(isAccessibilityEnabled);
    return () => {
      accessibilityHelper.cleanupAccessibility();
    };
  }, [accessibilityHelper, isAccessibilityEnabled]);
  return {
    isAccessible
  };
};
export default class AccessibilityHelper {
  constructor(setAccessibilyState) {
    _defineProperty(this, "setAccessibilityStateCB", void 0);
    _defineProperty(this, "tabWasPressed", void 0);
    _defineProperty(this, "eventActive", void 0);
    _defineProperty(this, "waitForFirstTabPress", event => {
      if (event.keyCode === 9) {
        event.preventDefault();
        this.cleanupAccessibility();
        this.tabWasPressed = true;
        // if (totalItemsCount > 1) { //TODO when we create the native tooltip we will need this here!
        //   loadAccessibilityTooltipComponent();
        // }
        this.setAccessibilityStateCB(true);
      }
    });
    this.initAccessibility = this.initAccessibility.bind(this);
    this.cleanupAccessibility = this.cleanupAccessibility.bind(this);
    this.waitForFirstTabPress = this.waitForFirstTabPress.bind(this);
    this.tabWasPressed = false;
    this.eventActive = false;
    this.setAccessibilityStateCB = setAccessibilyState;
  }
  initAccessibility(accessibilityEnabled) {
    if (accessibilityEnabled === void 0) {
      accessibilityEnabled = true;
    }
    if (accessibilityEnabled) {
      this.eventActive = true;
      const {
        addEventListener
      } = window || {
        addEventListener: () => {}
      };
      addEventListener('keydown', this.waitForFirstTabPress);
    }
  }
  cleanupAccessibility() {
    if (this.eventActive) {
      const {
        removeEventListener
      } = window || {
        removeEventListener: () => {}
      };
      removeEventListener('keydown', this.waitForFirstTabPress);
    }
  }
}
//# sourceMappingURL=nativeAccessibilityHelper.js.map